// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.only-page-size__label_7cb082b1 {
  color: #11304d;
  font-weight: 400;
  margin-bottom: 0;
}
.only-page-size__label-root_7cb082b1 {
  margin-bottom: 0 !important;
}
.only-page-size__combo-box_7cb082b1 {
  width: 7.5rem;
}
.show-results-combobox_7cb082b1 {
  width: 13.334rem;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"only-page-size__label": `only-page-size__label_7cb082b1`,
	"only-page-size__label-root": `only-page-size__label-root_7cb082b1`,
	"only-page-size__combo-box": `only-page-size__combo-box_7cb082b1`,
	"show-results-combobox": `show-results-combobox_7cb082b1`
};
export default ___CSS_LOADER_EXPORT___;
